import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, InputNumber, message } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import OrdemProducaoItemForm from './OrdemProducaoItemForm';
import AnaliseProducaoForm from '../components/AnaliseProducaoForm';
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from "../utils/Colors";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;



export default class OrdemProducaoForm extends Component {
  state = {
    registro: {
      op_idf: 0,
      op_numero: '',
      op_dt_emissao: moment().format('DD/MM/YYYY'),
      op_dt_entrega: moment().format('DD/MM/YYYY'),
      op_pessoa: { key: '0' },
      op_prioridade: 1,
      op_obs: '',
    },
    registroSelecionado: {},
    modalProdutoVisible: false,
    modalListaVisible: false,
    formVisivelAnalise: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,

    activeKey: "dados",

    listaProdutos: [],
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {

      const usuario = getUsuario();

      this.setState({
        registro: this.props.registroSelecionado.dados,
        op_pessoa: this.props.registroSelecionado.dados.op_pessoa,
        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        visualizando: this.props.registroSelecionado.dados.visualizando,
        usuario,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.setState({
          op_pessoa: {
            key: this.props.registroSelecionado.dados.op_pessoa.key,
            label: this.props.registroSelecionado.dados.op_pessoa.label
          },
        });
      });

      if (this.props.registroSelecionado.dados.op_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    // const usuario = getUsuario();
    // this.setState({
    //   usuario,
    // });
  }

  onOK = () => {
    if ((!this.state.registro.op_dt_emissao) || (!moment(this.state.registro.op_dt_emissao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.op_pessoa) || (this.state.registro.op_pessoa.key === '0') || (this.state.registro.op_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.listaProdutos) || (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na Ordem de Produção' });
      return;
    }

    const registro = {
      op_idf: this.state.registro.op_idf,
      op_dt_emissao: moment(this.state.registro.op_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      op_numero: this.state.registro.op_numero ? this.state.registro.op_numero : '0',
      op_pessoa: this.state.op_pessoa.key,
      op_prioridade: this.state.op_prioridade,
      op_obs: this.state.registro.op_obs,

      listaProdutos: this.state.listaProdutos,
    };

    this.props.onSalvarClick(registro);
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['op_pessoa'] = event.op_pessoa;
    this.setState(event);
  }

  onInputChangePrioridade = event => {
    const value = event;
    const id = 'op_prioridade';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }



  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    });
  }

  onNovoProduto = (event) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: false,
        registro: {
          pi_seq: 0,
          pi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          pi_qtde: 1,
          pi_peso_real: 1,
          pi_dt_producao: moment().format('DD/MM/YYYY'),
          pi_dt_entrega: moment().format('DD/MM/YYYY'),
          pi_hora: '00:00',
          pi_obs: '',
        }
      }
    });
  }

  onEditarProdutosClick = (reg) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: true,
        registro: {
          pi_item: {
            key: String(reg.pi_item),
            label: reg.prod_descricao,
            prod_codigo: reg.prod_codigo,
            prod_descricao: reg.prod_descricao,
            prod_preco_tab1: reg.prod_preco_tab1,
            prod_preco_tab2: reg.prod_preco_tab2,
          },
          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          pi_qtde: reg.pi_qtde,
          pi_peso_real: reg.pi_peso_real,
          pi_dt_producao: moment(reg.pi_dt_producao, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          pi_dt_entrega: moment(reg.pi_dt_entrega, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          pi_obs: reg.pi_obs,
        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf === reg.prod_idf);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        });
      }
    })
  }



  renderAcoesProdutos = (registro) => {
    return (
      <div>
        {getTemPermissao('AnaliseProducaoPage', 'editar') ? (
          <ButtonGroup size="small" style={{ marginRight: 10 }}>
            {registro.ap_idf ? (
              <Tooltip title="Editar Análise Laboratorial" placement="top">
                <Button className="botoesModalFormVisualizar" onClick={() => this.onEditarAnaliseClick(registro.ap_idf)} icon="medicine-box" />
              </Tooltip>
            ) : this.state.registro.op_idf ? (
              <Tooltip title="Gerar Análise Laboratorial" placement="top">
                <Button className="botoesModalFormVisualizar" onClick={() => this.onAddAnaliseClick(registro)} icon="medicine-box" />
              </Tooltip>
            ) : null}
          </ButtonGroup>
        ) : null}
        <ButtonGroup size="small">
          {this.state.visualizando ? null : (
            <Tooltip title="Editar Produto" placement="top">
              <Button className="botoesModalFormEditar" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
            </Tooltip>
          )}
          {this.state.visualizando ? null : (
            <Tooltip title="Excluir Produto" placement="top">
              <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
            </Tooltip>
          )}
        </ButtonGroup>
      </div>
    );
  };



  // ----------------------------------------------------------------

  onCancelarAnaliseClick = () => {
    this.setState({
      formVisivelAnalise: false
    })
  }

  onAddAnaliseClick = (registro) => {

    Modal.confirm({
      title: 'Gerar Análise Laboratorial',
      content: `Deseja gerar as análise laboratorial deste item da Produção?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {

        const reg = {
          listaPedidos: [this.state.registro.op_idf + '_' + this.state.registro.op_pessoa.key + '_' + registro.pi_item + '_' + registro.pi_seq + '_' + registro.pi_qtde + '_' + registro.pi_obs],
          pi_dt_producao: moment().format('YYYY-MM-DD'),
          tipo: 'PROD',
        }

        // console.log(reg)
        // return;

        this.setState({ carregando: true })

        axios.post(`/analiseProducao/storeAnalisePedidos`, reg)
          .then(response => {
            message.success('Análise gravada com sucesso');

            const listaProdutos = [...this.state.listaProdutos];
            const index = listaProdutos.findIndex(regtr => regtr.pi_item === registro.pi_item && regtr.pi_seq === registro.pi_seq);
            listaProdutos[index].ap_idf = response.data;
            this.setState({
              listaProdutos,
            });

            this.setState({ carregando: true });
            axios.get(`/analiseProducao/show/${response.data}`)
              .then(response => {
                const { data } = response;

                data.dados.ap_cliente = {
                  key: String(data.dados.ap_cliente),
                  label: data.dados.pes_nome,
                }
                data.dados.ap_produto = {
                  key: String(data.dados.ap_produto),
                  label: data.dados.prod_descricao,
                }
                data.dados.ap_protocolo = {
                  key: String(data.dados.ap_protocolo),
                  label: '',
                }
                data.dados.ap_categoria = {
                  key: String(data.dados.ap_categoria),
                  label: '',
                }
                data.dados.ap_data_amostras = moment(data.dados.ap_data_amostras, 'YYYY-MM-DD').format('DD/MM/YYYY');
                data.dados.ap_data_fabricacao = moment(data.dados.ap_data_fabricacao, 'YYYY-MM-DD').format('DD/MM/YYYY');
                data.dados.ap_data_validade = moment(data.dados.ap_data_validade, 'YYYY-MM-DD').format('DD/MM/YYYY');

                data.dados.visualizando = data.dados.ap_status === 2 ? true : false;

                this.setState({
                  formVisivelAnalise: true,
                  registroSelecionado: data,
                  carregando: false,
                })
              })
              .catch(error => {
                console.error(error.response);
                this.setState({
                  carregando: false,
                })
              })

          })
          .catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Falha ao Gravar', content: error.response.data, });
            } else {
              Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  }

  onSalvarAnaliseClick = (registro) => {
    // console.log('onSalvarAnaliseClick', registro)
    this.setState({
      salvando: true
    })
    let request;
    if (registro.ap_idf) {
      request = axios.put(`/analiseProducao/update/${registro.ap_idf}`, registro);
    } else {
      request = axios.post(`/analiseProducao/store`, registro)
    }
    request
      .then(response => {
        this.setState({
          formVisivelAnalise: false,
          salvando: false,
        })
        message.success('Análise Laboratorial gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          formVisivelAnalise: false,
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }

  onEditarAnaliseClick = (ap_idf) => {
    this.setState({ carregando: true });
    axios.get(`/analiseProducao/show/${ap_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.ap_cliente = {
          key: String(data.dados.ap_cliente),
          label: data.dados.pes_nome,
        }
        data.dados.ap_produto = {
          key: String(data.dados.ap_produto),
          label: data.dados.prod_descricao,
        }
        data.dados.ap_protocolo = {
          key: String(data.dados.ap_protocolo),
          label: '',
        }
        data.dados.ap_categoria = {
          key: String(data.dados.ap_categoria),
          label: '',
        }
        data.dados.ap_data_amostras = moment(data.dados.ap_data_amostras, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.ap_data_fabricacao = moment(data.dados.ap_data_fabricacao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.ap_data_validade = moment(data.dados.ap_data_validade, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.visualizando = data.dados.ap_status === 2 ? true : false;

        this.setState({
          formVisivelAnalise: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };






  // ----------------------------------------------------------------



  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }



  renderValor = (valor) => {
    return (
      <span> {numeral(parseFloat(valor)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }



  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoForm, listaProdutos, produtoSelecionado, modalProdutoVisible, formVisivelAnalise, registroSelecionado, salvando } = this.state;
    const { op_idf, op_numero, op_dt_emissao, op_pessoa, op_prioridade, op_obs, } = this.state.registro;

    // console.log('OrdemProducaoForm.this.state: ', this.state);

    return (
      <Modal
        title={op_idf ? (this.state.visualizando ? "Produção" : "Edição de Produção") : "Inclusão de Produção"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <OrdemProducaoItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          produtoSelecionado={produtoSelecionado}
        />

        <AnaliseProducaoForm
          visivel={formVisivelAnalise}
          onSalvarClick={this.onSalvarAnaliseClick}
          onCancelarClick={this.onCancelarAnaliseClick}
          carregando={salvando}
          registroSelecionado={registroSelecionado}
        />


        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <div className="div-subTitulo">
                      <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                        Dados da Produção
                      </span>
                    </div>

                    <Col xs={24} sm={4} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="op_numero"
                        ref="op_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={op_numero}
                        readOnly
                      />
                    </Col>

                    <Col xs={24} sm={4} className="camposEspacoDireita">
                      <span>Prioridade</span>
                      <InputNumber
                        ref="Input"
                        id={op_prioridade}
                        value={op_prioridade}
                        onChange={this.onInputChangePrioridade}
                        min={1}
                        max={3}
                        maxLength={1}
                        style={{ width: '100%' }}
                      />
                    </Col>

                    <Col xs={24} sm={6} style={{ marginTop: 0 }}>
                      <span>Data Emissão</span>
                      <InputForm
                        type="date"
                        id="op_dt_emissao"
                        ref="op_dt_emissao"
                        value={op_dt_emissao}
                        masker={maskDate}
                        validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                        dateFormat="DD/MM/YYYY"
                        onChange={this.onChange}
                        errorMessage="Formato correto DD/MM/AAAA"
                        className="input-data-avaliacao"
                        style={{ width: "100%" }}
                      // disabled={op_idf ? true : false}
                      />
                    </Col>


                    <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                      <PessoaFrame
                        label="Cliente"
                        id="op_pessoa"
                        value={op_pessoa}
                        tipo="C"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        descricaoPrimeiroItem="Selecione um Cliente"
                      />
                    </Col>


                    <Col xs={24} style={{ marginTop: -20 }}>
                      <span>OBS</span>
                      <InputForm
                        id="op_obs"
                        ref="op_obs"
                        value={op_obs}
                        maxLength={200}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>

                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Lista dos Produtos" key="produtos">
              <div style={{ height: 350 }}>
                {this.state.visualizando ? null : (
                  <Row>
                    <Col xs={24} style={{ marginTop: -60, marginRight: 20 }}>
                      <Tooltip title="Adicionar Produtos Avulsos">
                        <Button
                          htmlType="button"
                          onClick={this.onNovoProduto}
                          icon="plus"
                          className="botoesModalForm2x"
                        > Novo Produto
                        </Button>
                      </Tooltip>
                    </Col>
                  </Row>
                )}
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  pagination={false}
                  scroll={{ y: 300 }}
                  rowKey={(listaProdutos => listaProdutos.pi_item)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={"8%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={"20%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pi_qtde"
                    dataIndex="pi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={"8%"}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="pi_peso_real"
                    dataIndex="pi_peso_real"
                    title="Peso"
                    render={this.renderValor}
                    width={"8%"}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="pi_dt_producao"
                    dataIndex="pi_dt_producao"
                    title="Data Produção"
                    render={this.renderData}
                    width={"10%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="pi_dt_entrega"
                    dataIndex="pi_dt_entrega"
                    title="Data Entrega"
                    render={this.renderData}
                    width={"10%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="ven_numero"
                    dataIndex="ven_numero"
                    title="Pedido"
                    width={"8%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pi_obs"
                    dataIndex="pi_obs"
                    title="OBS"
                    width={"15%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={"25"}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizando ? null : (
                  <Button
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar Produção
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrdemProducaoForm.js